import React from 'react'
import PropTypes from 'prop-types'

const ProsConsList = ({ title, items, variant, symbol }) => (
  <section className={`hotel-pros-cons-column hotel-pros-cons-${variant}`}>
    <h3 className="hotel-pros-cons-heading">
      <span className="hotel-pros-cons-symbol" aria-hidden="true">
        {symbol}
      </span>
      {title}
    </h3>
    <ul>
      {items.map((item, index) => (
        <li key={`${variant}-${index}`}>{item}</li>
      ))}
    </ul>
  </section>
)

ProsConsList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  variant: PropTypes.oneOf(['pros', 'cons']).isRequired,
  symbol: PropTypes.string.isRequired,
}

const HotelProsCons = ({ prosCons }) => {
  const pros = (prosCons?.pros || []).filter(Boolean)
  const cons = (prosCons?.cons || []).filter(Boolean)

  if (pros.length === 0 && cons.length === 0) {
    return null
  }

  return (
    <aside className="hotel-pros-cons" aria-label="Hotel pros and cons">
      {pros.length > 0 ? (
        <ProsConsList title="Pros" items={pros} variant="pros" symbol="+" />
      ) : null}
      {cons.length > 0 ? (
        <ProsConsList title="Cons" items={cons} variant="cons" symbol="-" />
      ) : null}
    </aside>
  )
}

HotelProsCons.propTypes = {
  prosCons: PropTypes.shape({
    pros: PropTypes.arrayOf(PropTypes.string),
    cons: PropTypes.arrayOf(PropTypes.string),
  }),
}

export default HotelProsCons
